import { City } from './types';
import { majorCities } from './major-cities';
import { mediumCities } from './medium-cities';
import { smallCities } from './small-cities';

// Export the individual city arrays
export { majorCities, mediumCities, smallCities };

// Combine all cities
export const illinoisCities: City[] = [
  ...majorCities,
  ...mediumCities,
  ...smallCities
].sort((a, b) => a.name.localeCompare(b.name));

export type { City };